
import { Bar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  components: { Bar },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartData: [],
      chartLabels: [],
      filteredChartData: {},
      forceReRender: 0,
      completedSteps: 0,
      totalSteps: 100,
      // esgActiveReportMobile: 1,
      // barChartLabels: ['2015', '2017', '2019', '2021'],
      // barChartValues: [
      //   // 1.15, 1.15, 2.3, 2.3, 2.3, 2.3, 2.3, 3.45, 3.45, 3.45, 3.45, 4.6, 4.6,
      //   // 6.9, 9.2, 9.2, 9.2, 10.34, 11.49, 12.64, 12.64, 13.79, 14.94, 16.09,
      //   // 17.24, 19.54, 20.69, 22.99, 25.29, 26.44, 26.44, 26.44, 26.44, 27.59,
      //   // 28.74, 31.03, 33.33, 34.48, 35.69, 37.93, 40.23, 41.38, 45.89, 48.28,
      //   // 57.47, 62.07, 67.82, 74.71, 80.46, 83.91, 88.51, 91.95, 91.95, 94.25,
      //   // 97.7, 100, 103.45, 106.9, 109.2, 112.64, 116.09, 120.69, 127.59, 143.68,
      //   // 165.52, 211.49, 234.48, 272.41, 313.79, 332.18, 402.3, 425.29, 500,
      //   14778846,
      //   15820721, 16120621, 16465836, 19912628, 21092121, 22471094, 25135119,
      //   27582966, 31100586, 39478779, 45415433, 48244931, 52648330, 55659144,
      //   57350454, 62243957, 66559800, 72670302, 75740704, 78327041, 87939091,
      //   100076324, 103193954, 109242472, 116307176, 189911610, 192984942,
      //   196261897, 199831856, 202754452, 208016927, 214316905, 227802734,
      //   236864418, 242388142, 248818868, 256448996, 275211201, 288381727,
      //   324190532, 344558405, 365800422, 401005297, 422870459, 439260130,
      //   463281291, 478837558, 488288357, 496610696, 506326513, 523023498,
      //   535736993, 549045427, 564729496, 573589648, 587689614, 603857625,
      //   639057917, 694891411, 849171762, 1015042738, 1145694688, 1311893796,
      //   1479525815, 1566288924, 1841489532, 1933619458, 2032909704, 2210247265,
      //   2372404944, 2508666588, 2604204874, 2713258517, 2855706081, 2983709494,
      //   3057137465, 3232812862, 3288767962, 3332952757, 3403885570, 3465705609,
      //   3959336721, 4029998497, 4035076234,
      // ],
    }
  },
  async fetch() {
    return await this.$axios
      .get('https://v2-api.wellcertified.com/api/well/mom-stats')
      .then((res) => {
        this.chartData = this.formatChartData(res.data)
        this.chartLabels = this.formatChartLabels(res.data)
      })
      .then(() => {
        if (this.$matchMedia('md')) {
          this.updateChart()
        } else {
          this.updateChart(true)
        }
      })
      .catch((res) => {
        if (!res.response) {
          console.error('no res', res)
        }
      })
  },
  computed: {
    formatedStats() {
      const stats = this.$store.state.settings.stats

      return this.blok.stat_list.map((listItem, index) => {
        const listItemCopy = { ...listItem }

        // use static if true
        if (listItem.useStatic) {
          listItemCopy.num = listItem.num
          return listItemCopy
        }

        // locations
        if (index === 1 && stats?.stat_certified && stats?.stat_registered) {
          const num =
            parseFloat(stats.stat_certified.replace(/,/g, '')) +
            parseFloat(stats.stat_registered.replace(/,/g, ''))
          listItemCopy.num = num.toLocaleString() + '+'
        }

        // square feet
        if (index === 2 && stats?.stat_area) {
          const num = stats.stat_area.replace(/billion/gi, 'B') + '+'
          listItemCopy.num = num.replace(/ /g, '')
        }

        // countries
        if (index === 3 && stats?.stat_countries) {
          listItemCopy.num = stats.stat_countries + '+'
        }

        return listItemCopy
      })
    },
    // barChartData() {
    //   return {
    //     labels: this.barChartValues,
    //     datasets: [
    //       {
    //         label: '',
    //         backgroundColor: '#3A7297',
    //         data: this.barChartValues,
    //       },
    //     ],
    //   }
    // },
    // barChartDataMobile() {
    //   // slice data - show more recent data to shrink width
    //   return {
    //     labels: this.chartLabels.slice(35),
    //     datasets: [
    //       {
    //         backgroundColor: '#3A7297',
    //         data: this.chartData.slice(35),
    //         // barThickness: 6,
    //       },
    //     ],
    //   }
    // },
    barChartOptions() {
      const newOptions = {
        responsive: true,
        maintainAspectRatio: false,
        // indexAxis: 'y',
        scales: {
          y: {
            position: 'right',
            ticks: {
              // padding: 10,
              color: '#000',
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              callback(value, index, ticks) {
                if (index === 0) return null
                return Number(value) / 1000000000 + ' B' || null
              },
              beginAtZero: false,
            },
            grid: {
              display: true,
              tickColor: 'rgba(60, 158, 183, .5)',
              color: 'rgb(247, 250, 253, .5)',
              drawBorder: false, // <-- this removes y-axis line
            },
            // beginAtZero: true,
          },
          x: {
            // display: false,
            // min: 0,
            // max: 90,
            ticks: {
              // padding: 10,
              color: '#fff',
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
            },
            grid: {
              borderColor: '#fff',
              display: false,
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false, // <-- this option disables tooltips
          },
        },
      }

      return newOptions
    },
  },
  watch: {
    '$store.state.app.breakpoint'(val) {
      if (this.$matchMedia('md')) {
        this.updateChart()
      } else {
        this.updateChart(true)
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.initAnimation()

      setTimeout(() => {
        this.completedSteps = 25
      }, 1000)
    })
  },
  methods: {
    initAnimation() {
      const gsap = this.$gsap

      const TL1 = gsap.timeline({
        scrollTrigger: {
          scrub: true,
          trigger: '#sections-chart',
          start: '10% bottom',
          end: 'bottom bottom',
          toggleActions: 'restart',
        },
      })

      TL1.from('#chart', {
        alpha: 0,
        duration: 1.25,
        onToggle: this.animateChart,
        onStart: () => this.animateChart(),
      })

      TL1.from('.animate', {
        alpha: 0,
        duration: 1.25,
        stagger: 0.15,
      })

      TL1.from('.graph-line', {
        scaleX: 0,
        duration: 3,
        stagger: 0.15,
        ease: 'Power3.easeInOut',
      })

      TL1.from('.graph-marker', {
        alpha: 0,
        duration: 3,
        stagger: 0.15,
        ease: 'Power3.easeInOut',
      })
    },
    formatChartData(data) {
      const formattedData = data.reduce((prev, current) => {
        const [num, area] = current?.total_area?.split(' ') ?? [null, null]
        if (!num || !area) {
          return null
        }
        const clonePrev = [...prev]

        switch (area.toLowerCase()) {
          case 'thousand':
            clonePrev.push(Number(num * 1000).toFixed(0))
            break
          case 'million':
            clonePrev.push(Number(num * 1000000).toFixed(0))
            break
          case 'billion':
            clonePrev.push(Number(num * 1000000000).toFixed(0))
            break
          default:
            return null
        }
        return clonePrev
      }, [])

      return formattedData
    },
    formatChartLabels(data) {
      // const formattedLabels = data.map((x) => x.year)
      let prev = null
      const formattedLabels = data.reduce((acc, next) => {
        let nextLabel = null

        if (prev === next.year) {
          nextLabel = ''
        } else {
          nextLabel = next.year
        }

        prev = next.year

        return [...acc, nextLabel]
      }, [])

      return formattedLabels
    },
    updateChart(isMobile = false) {
      this.filteredChartData = {
        labels: isMobile ? this.chartLabels.slice(50) : this.chartLabels,
        datasets: [
          {
            backgroundColor: '#3A7297',
            data: isMobile ? this.chartData.slice(50) : this.chartData,
            // barThickness: 6,
          },
        ],
      }
    },
    animateChart() {
      this.forceReRender += 1
    },
  },
}
